// services/streamBaseQuery.ts
import { BaseQueryFn } from '@reduxjs/toolkit/query';

export const streamBaseQuery: BaseQueryFn<
  { url: string; body: any },
  string[],
  unknown
> = async ({ url, body }) => {
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'text/event-stream',
      },
      body: JSON.stringify(body),
    });

    if (!response.body) {
      throw new Error('ReadableStream not supported');
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let result: string[] = [];

    while (true) {
      const { done, value } = await reader.read();
      if (done) break;
      const chunk = decoder.decode(value);
      // Split lines if multiple lines received at once
      const lines = chunk.split('\n').map((l) => l.trim()).filter(Boolean);

      for (const line of lines) {
        if (line === '[DONE]') continue;
        result.push(line);
      }
    }

    return { data: result };
  } catch (error) {
    return { error: { status: 'FETCH_STREAM_ERROR', data: error } };
  }
};
